import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';

import { IReduxState } from 'src/store';
import { scrollToTop } from 'src/utils';

import AuthScreen from 'src/screens/auth/auth.component';
import RedirectScreen from 'src/screens/auth/redirect/redirect.component';
import NotFound from 'src/screens/error/404/404.component';

const PrivateRoute: React.FC = ({ children }: any) => {
  scrollToTop();

  const [cookies] = useCookies();

  const token = !!useSelector((state: IReduxState) => state.auth?.token);
  const cookieToken = !!cookies?._jwtToken;

  const hasAccess = token && cookieToken;
  const hasPartialAccess = !token && cookieToken;

  return hasAccess ? (
    <Navigate to="/painel" replace />
  ) : hasPartialAccess ? (
    children?.type?.WrappedComponent?.name === 'RedirectScreen' ? (
      children
    ) : (
      <Navigate to="redirect" replace />
    )
  ) : (
    children
  );
};

const GuestRoutes = (
  <>
    <Route path="/">
      <Route index element={<PrivateRoute children={<AuthScreen />} />} />
      <Route
        path="redirect"
        element={<PrivateRoute children={<RedirectScreen />} />}
      />
    </Route>
    <Route path="*" element={<NotFound />} />
  </>
);

export default GuestRoutes;
